module.exports = __webpack_public_path__ + "img/web-development.a5e868e4.png";